import { render, staticRenderFns } from "./modal-task-link.vue?vue&type=template&id=ae0a3ae4&scoped=true&"
import script from "./modal-task-link.vue?vue&type=script&lang=js&"
export * from "./modal-task-link.vue?vue&type=script&lang=js&"
import style0 from "./modal-task-link.vue?vue&type=style&index=0&id=ae0a3ae4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0a3ae4",
  null
  
)

export default component.exports